import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppClientComponent implements OnInit
{

  public isLoaded: boolean = false;
  public OpenPay: any;

  constructor(private router: Router) {}

  ngOnInit()
  {
    this.router.events.subscribe(route =>
    {
      if (route instanceof NavigationEnd)
      {
        if (route.url.contains("/ecommerce")) { }
      }
    });
  }
}
